import React from 'react';

const Messages = ()=>{
   return(
       <div> Woooow, soooo many messages!</div>
   )
}






export default Messages